import { Box } from '@trmediaab/zebra';
import { useRef } from 'react';
import ReactPlayer from 'react-player/lazy';
import { history } from 'redux-first-router';
import styled from 'styled-components';

import { videoType } from '~/utils/prop-types';

const Root = styled.div`
  position: relative;
  margin-bottom: 20px;
  padding-bottom: calc(100% / (16 / 9));
`;

const StyledPlayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

const MediaPlayer = ({ video }) => {
  const isStreamio = video.supplier === 'streamio';
  const config = useRef({
    youtube: {
      playerVars: { modestbranding: 1 },
      widget_referrer:
        import.meta.env.VITE_CANONICAL_ROOT + history().location.pathname,
    },
  });

  return (
    <Root>
      {isStreamio ? (
        <Box
          as="iframe"
          width="100%"
          height="100%"
          src={video.url}
          title={video.title}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          css={`
            position: absolute;
            top: 0;
            left: 0;
          `}
        />
      ) : (
        <ReactPlayer
          url={video.url}
          config={config.current}
          width="100%"
          height="100%"
          wrapper={StyledPlayer}
          controls
        />
      )}
    </Root>
  );
};

MediaPlayer.propTypes = {
  video: videoType.isRequired,
};

export default MediaPlayer;
